"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
var react_1 = require("react");
var useResize_1 = require("./useResize");
var useWindowSize = function (wait) {
    if (wait === void 0) { wait = 250; }
    var _a = (0, react_1.useState)({
        width: window.innerWidth,
        height: window.innerHeight,
    }), windowSize = _a[0], setWindowSize = _a[1];
    var getWindowSize = (0, react_1.useCallback)(function () { return ({
        width: window.innerWidth,
        height: window.innerHeight,
    }); }, []);
    (0, useResize_1.useResize)(function () {
        setWindowSize(getWindowSize);
    }, wait);
    return windowSize;
};
exports.useWindowSize = useWindowSize;
